
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")



export const insertLines = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"line/insert-lines", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};




export const getList = async (lotId) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.get(URL_BASE+"line/list/"+lotId, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const getLine = async (lineId) => {
    const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
    try {
      const response = await axios.get(URL_BASE+"line/get/"+lineId, config)
      const line = response.data?.data || null;
      return line;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  


export const insert = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"line/insert", data, config)
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const deleteLine = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"line/delete-line", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};




export const insertLine = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"line/insert-line", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};


  export default{
    getLine,
    getList,
    insert,
    insertLines,
    insertLine,
    deleteLine
  }

